export default "<template>\n\n</template>\n\n<script>\nexport default {\n\n};\n</script>\n";